/* eslint-disable */
import ThemeSwitcher from '../components/ThemeSwitcher';
// AUTO-GENERATED from /officer-app by scripts/html2jsx.mjs — markup preserved 1:1.
export const bodyClass = "bg-slate-950 text-slate-100 min-h-screen py-0 md:py-6 flex flex-col items-center justify-center font-sans antialiased";

export default function OfficerMarkup() {
  return (
    <>
      {/* TOP BAR (PORTAL SWITCHER & THEME SELECTOR) */}
      <div className="w-full max-w-md px-3 py-2 mb-2 flex items-center justify-between text-xs text-slate-400">
        <a href="/admin" className="flex items-center gap-1 text-blue-400 hover:text-blue-300 font-bold">
          <span>
            ←
          </span>
          {' '}Admin Command
        </a>
        {/* Pleasant Theme Switcher */}
        <ThemeSwitcher />
        <div className="flex items-center gap-2">
          <button onClick={(event) => { openApkModal() }} className="px-2 py-1 bg-emerald-600 hover:bg-emerald-500 text-white rounded text-[11px] font-bold flex items-center gap-1 shadow">
            <span>
              📲
            </span>
            {' '}APK
          </button>
          <a href="/sector-patrol" className="text-slate-300 hover:text-white">
            Superior 🚓
          </a>
          <span className="text-slate-600">
            |
          </span>
          <a href="/login" className="text-slate-300 hover:text-white">
            Logout 🚪
          </a>
        </div>
      </div>
      {/* SMARTPHONE APP CONTAINER */}
      <div className="mobile-device-shell w-full max-w-md bg-slate-900 border border-slate-800 shadow-2xl flex flex-col overflow-hidden relative">
        {/* STATUS BAR */}
        <div className="bg-slate-950 px-5 py-2 flex items-center justify-between text-[11px] text-slate-400 font-mono shrink-0 select-none">
          <span id="phone-clock">
            09:41 AM
          </span>
          <div className="flex items-center gap-2">
            <span className="text-[10px] text-emerald-400 font-bold flex items-center gap-1">
              <span className="w-1.5 h-1.5 rounded-full bg-emerald-400 animate-pulse"></span>
              {' '}4G GPS LIVE
            </span>
            <span>
              🔋 88%
            </span>
          </div>
        </div>
        {/* APK INSTALL / MOBILE BANNER */}
        <div className="bg-indigo-950/90 border-b border-indigo-700/50 px-3.5 py-1.5 flex items-center justify-between text-[11px] text-indigo-200 shrink-0">
          <div className="flex items-center gap-1.5 truncate">
            <span className="text-sm">
              📱
            </span>
            <span className="truncate font-semibold">
              Staff Android APK Available (.apk)
            </span>
          </div>
          <button onClick={(event) => { openApkModal() }} className="shrink-0 px-2.5 py-0.5 bg-emerald-600 hover:bg-emerald-500 text-white rounded font-bold text-[10px] shadow transition">
            Install / Download
          </button>
        </div>
        {/* APP HEADER */}
        <div className="bg-gradient-to-r from-blue-900 via-indigo-900 to-slate-900 px-4 py-3.5 border-b border-slate-800 shrink-0">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-2.5">
              <div className="w-10 h-10 rounded-xl bg-blue-600 text-white flex items-center justify-center text-lg font-bold shadow-md border border-blue-400/40">
                👮
              </div>
              <div>
                <h2 id="staff-name" className="text-sm font-black text-white leading-tight">
                  Loading Staff...
                </h2>
                <div id="staff-designation" className="text-[11px] text-blue-300 font-medium">
                  Police Constable (PC)
                </div>
                <div id="staff-phone" className="text-[10px] text-slate-400 font-mono">
                  +91 98765 00000
                </div>
              </div>
            </div>
            {/* Quick Switcher */}
            <div className="text-right">
              <label className="block text-[9px] uppercase font-bold text-slate-400 mb-0.5">
                Switch Staff:
              </label>
              <select id="staff-switcher-select" className="bg-slate-950 text-white text-[11px] rounded px-2 py-1 border border-slate-700 max-w-[130px] truncate">
                {/* Injected dynamically */}
              </select>
            </div>
          </div>
        </div>
        {/* SCROLLABLE APP BODY */}
        <div className="flex-1 overflow-y-auto p-4 space-y-4">
          {/* DUTY & GEOFENCE STATUS CARD */}
          <div id="duty-status-card" className="rounded-2xl p-4 bg-slate-800/80 border border-slate-700 shadow-lg">
            <div className="flex items-center justify-between mb-2">
              <span className="text-[11px] font-bold text-slate-400 uppercase tracking-wider">
                Live Duty Verification
              </span>
              <span id="duty-badge" className="px-2.5 py-0.5 rounded-full text-xs font-bold bg-slate-700 text-slate-300">
                FETCHING GPS...
              </span>
            </div>
            <h3 id="duty-title" className="text-base font-bold text-white mb-1">
              Calculating Distance to Polling Booth...
            </h3>
            <p id="duty-desc" className="text-xs text-slate-300 leading-relaxed mb-3">
              Your live GPS coordinates are continuously recorded and stored for 24-hour compliance tracking by Admin & Sub-Inspector.
            </p>
            {/* Distance & GPS Coordinates Grid */}
            <div className="grid grid-cols-2 gap-2 bg-slate-950/70 p-2.5 rounded-xl border border-slate-800/80 text-xs">
              <div>
                <div className="text-[10px] text-slate-400 uppercase font-semibold">
                  Deviation Distance
                </div>
                <div id="live-distance-value" className="text-base font-black text-emerald-400 font-mono">
                  0 meters
                </div>
              </div>
              <div>
                <div className="text-[10px] text-slate-400 uppercase font-semibold">
                  Live GPS Coords
                </div>
                <div id="live-coordinates" className="text-[11px] font-bold text-white font-mono truncate">
                  --
                </div>
              </div>
              <div>
                <div className="text-[10px] text-slate-400 uppercase font-semibold">
                  Geofence Radius
                </div>
                <div className="text-xs font-bold text-slate-300 font-mono">
                  ≤ 75 meters
                </div>
              </div>
              <div>
                <div className="text-[10px] text-slate-400 uppercase font-semibold">
                  Last Cloud Ping
                </div>
                <div id="last-sync-time" className="text-[11px] font-bold text-blue-400 font-mono">
                  Just Now
                </div>
              </div>
            </div>
          </div>
          {/* NON-ATTENDANCE WARNING BANNER (Hidden by default) */}
          <div id="non-attended-banner" className="hidden bg-rose-950 border-2 border-rose-500 rounded-xl p-3 text-xs text-rose-200">
            <strong className="text-white block font-bold text-sm mb-1">
              ✕ DUTY NON-ATTENDANCE RECORDED
            </strong>
            {' '}Your allotted Sub-Inspector has received an automated alert that you have not attended duty at your booth. Please report immediately or contact your SI.
          </div>
          {/* ACTIVE SOS BANNER (Hidden by default) */}
          <div id="active-sos-banner" className="hidden bg-red-950 border-2 border-red-500 rounded-xl p-3 text-xs text-red-200 animate-sos-strobe">
            <div className="flex items-center justify-between mb-1">
              <span className="font-bold flex items-center gap-1.5 text-white">
                <span className="text-base animate-bounce">
                  🚨
                </span>
                {' '}SOS BROADCAST ACTIVE
              </span>
              <button id="btn-clear-sos" className="px-2 py-0.5 bg-red-600 hover:bg-red-700 text-white rounded text-[10px] font-bold">
                Clear Alarm
              </button>
            </div>
            <div className="text-[11px] text-red-300">
              Reason:{' '}
              <strong id="sos-reason-display" className="text-white">
                Emergency Reported
              </strong>
            </div>
          </div>
          {/* OFFLINE WARNING BANNER (Hidden by default) */}
          <div id="offline-warning-banner" className="hidden bg-slate-800 border border-slate-600 rounded-xl p-3 text-xs text-slate-300 flex items-start gap-2">
            <span className="text-base">
              ⚡
            </span>
            <div>
              <strong className="text-white block font-semibold">
                Device Running in Offline Mode
              </strong>
              {' '}GPS coordinates cached locally. Admin & Sub-Inspector notified of disconnected state.
            </div>
          </div>
          {/* ALLOTTED SUPERIOR OFFICERS COMMAND CARD */}
          <div className="bg-indigo-950/40 rounded-2xl p-3.5 border border-indigo-700/50 space-y-2">
            <div className="flex items-center justify-between">
              <span className="text-xs font-bold text-indigo-300 flex items-center gap-1.5">
                <span>
                  🚓
                </span>
                {' '}Allotted Superior Officers
              </span>
              <span className="text-[10px] text-indigo-400 font-mono">
                Chain of Command
              </span>
            </div>
            <div className="space-y-1.5 text-xs">
              {/* Station Sub-Inspector (Immediate Superior) */}
              <div className="p-2 bg-slate-950/80 rounded-xl border border-slate-800 flex items-center justify-between">
                <div>
                  <div className="text-[10px] text-slate-400 uppercase font-semibold">
                    Immediate Superior (SHO):
                  </div>
                  <div id="superior-si-name" className="font-bold text-white text-xs">
                    Sub-Inspector
                  </div>
                  <div id="superior-si-phone" className="text-[10px] text-indigo-300 font-mono">
                    +91 98765 00000
                  </div>
                </div>
                <a id="btn-call-superior-si" href="tel:+919876500000" className="px-3 py-1.5 bg-indigo-600 hover:bg-indigo-500 text-white rounded-lg text-xs font-bold transition flex items-center gap-1">
                  <span>
                    📞
                  </span>
                  {' '}Call SI
                </a>
              </div>
              {/* Circle Inspector */}
              <div className="text-[11px] text-slate-400 flex justify-between px-1">
                <span>
                  Circle Inspector:{' '}
                  <strong id="superior-inspector-name" className="text-slate-200">
                    Inspector
                  </strong>
                </span>
              </div>
            </div>
          </div>
          {/* GPS TRACKING CONTROLS & CONTINUOUS FETCH */}
          <div className="bg-slate-950/80 rounded-2xl p-3.5 border border-slate-800 space-y-2.5">
            <div className="flex items-center justify-between">
              <span className="text-xs font-bold text-slate-200 flex items-center gap-1.5">
                <span>
                  📍
                </span>
                {' '}Live Location Controls (24h Stored)
              </span>
              <span className="text-[10px] text-emerald-400 font-mono font-bold">
                Auto-Logged
              </span>
            </div>
            <button id="btn-toggle-real-gps" className="w-full py-2 bg-slate-800 hover:bg-slate-700 text-white rounded-xl text-xs font-bold border border-slate-700 transition flex items-center justify-center gap-2 shadow">
              <span>
                📍
              </span>
              {' '}Enable Real Phone GPS (watchPosition)
            </button>
            <div className="grid grid-cols-2 gap-2 pt-1 text-xs font-medium">
              <button id="btn-sim-at-booth" className="py-2 px-2 bg-emerald-950/60 hover:bg-emerald-900/80 text-emerald-300 rounded-xl border border-emerald-600/40 transition">
                ✓ Check-In at Booth (0m)
              </button>
              <button id="btn-sim-walk-away" className="py-2 px-2 bg-amber-950/60 hover:bg-amber-900/80 text-amber-300 rounded-xl border border-amber-600/40 transition">
                ⚠ Walk 180m Away
              </button>
              <button id="btn-sim-moving-patrol" className="py-2 px-2 bg-indigo-950/60 hover:bg-indigo-900/80 text-indigo-300 rounded-xl border border-indigo-600/40 transition">
                🚶 Walk Patrol (Live)
              </button>
              <button id="btn-sim-offline" className="py-2 px-2 bg-slate-800 hover:bg-slate-700 text-slate-300 rounded-xl border border-slate-700 transition">
                ⚡ Toggle Offline Mode
              </button>
            </div>
            {/* Non-Attendance Report Button */}
            <button id="btn-report-non-attendance" className="w-full py-1.5 bg-rose-950/60 hover:bg-rose-900/80 text-rose-300 rounded-xl text-xs font-bold border border-rose-700/50 transition">
              ✕ Report Duty Non-Attendance / Late / Relief Needed
            </button>
          </div>
          {/* ALLOTTED POLLING BOOTH DOSSIER */}
          <div className="bg-slate-800/60 rounded-2xl p-3.5 border border-slate-700/60 space-y-2">
            <div className="flex items-center justify-between">
              <span className="text-xs font-bold text-white flex items-center gap-1.5">
                <span>
                  🗳️
                </span>
                {' '}Allotted Polling Booth
              </span>
              <div className="flex items-center gap-1.5">
                <span id="booth-sensitivity" className="text-[10px]"></span>
                <span id="booth-code" className="text-xs font-bold font-mono px-2 py-0.5 rounded bg-blue-900/80 text-blue-300">
                  PS-0000
                </span>
              </div>
            </div>
            <div id="booth-name" className="text-sm font-bold text-slate-100 leading-snug">
              Govt Model School, Booth #1
            </div>
            <div className="text-[11px] text-slate-400 space-y-0.5 pt-1">
              <div>
                Station:{' '}
                <strong id="booth-station" className="text-slate-200">
                  --
                </strong>
              </div>
              <div>
                Circle:{' '}
                <span id="booth-circle" className="text-slate-300">
                  --
                </span>
              </div>
              <div>
                Sub-Division:{' '}
                <span id="booth-subdiv" className="text-slate-300">
                  --
                </span>
              </div>
              <div>
                Coordinates:{' '}
                <span id="booth-coords" className="font-mono text-slate-300">
                  --
                </span>
              </div>
            </div>
            <div className="pt-2">
              <a id="btn-nav-booth" href="#" target="_blank" className="w-full py-2 bg-blue-600 hover:bg-blue-500 text-white rounded-xl text-xs font-bold flex items-center justify-center gap-1.5 shadow transition">
                <span>
                  🗺️
                </span>
                {' '}Turn-by-Turn Directions in Google Maps
              </a>
            </div>
          </div>
          {/* EMERGENCY PING & ALARM TO SUPERIOR */}
          <div className="pt-1">
            <button id="btn-trigger-emergency-ping" className="w-full py-3.5 rounded-2xl bg-gradient-to-r from-red-600 via-rose-600 to-red-700 hover:from-red-500 hover:to-rose-500 text-white font-black text-xs tracking-wider uppercase shadow-xl shadow-red-900/50 flex items-center justify-center gap-2 border border-red-400 transition transform active:scale-95">
              <span className="text-xl">
                🚨
              </span>
              {' '}PING ALLOTTED SUPERIOR (SI / INSPECTOR)
            </button>
            <p className="text-[10px] text-slate-500 text-center mt-1">
              Instantly sends emergency alert message to your Sub-Inspector & SP Control Room
            </p>
          </div>
          {/* INCOMING ORDERS & MESSAGES FEED */}
          <div className="bg-slate-900 rounded-2xl p-3.5 border border-slate-800 space-y-2">
            <div className="flex items-center justify-between">
              <span className="text-xs font-bold text-white flex items-center gap-1.5">
                <span>
                  📩
                </span>
                {' '}Orders from Sub-Inspector & HQ
              </span>
              <span className="text-[10px] text-indigo-400 font-mono">
                Two-Way Live
              </span>
            </div>
            <div id="messages-feed-container" className="space-y-1.5 max-h-48 overflow-y-auto">
              {/* Injected dynamically */}
            </div>
            {/* Two-Way Direct Reply Box to Superiors */}
            <form id="officer-reply-form" onSubmit={(event) => { handleOfficerSendReply(event) }} className="pt-2 border-t border-slate-800 flex gap-1.5">
              <input type="text" id="officer-reply-text" required placeholder="Reply back to SI & Admin HQ..." className="flex-1 bg-slate-950 border border-slate-700 rounded-xl px-2.5 py-1.5 text-xs text-white placeholder-slate-500 focus:outline-none focus:border-indigo-500" />
              <button type="submit" className="px-3 py-1.5 bg-indigo-600 hover:bg-indigo-500 text-white rounded-xl text-xs font-bold transition shrink-0 flex items-center gap-1 shadow">
                <span>
                  Send
                </span>
                {' '}💬
              </button>
            </form>
          </div>
        </div>
        {/* BOTTOM TAB NAVIGATION */}
        <div className="bg-slate-950 border-t border-slate-800 px-4 py-2 flex items-center justify-around text-xs shrink-0">
          <button className="flex flex-col items-center text-blue-400 font-bold">
            <span className="text-base">
              📍
            </span>
            <span className="text-[10px]">
              Duty Status
            </span>
          </button>
          <a href="/emergency-sos" className="flex flex-col items-center text-rose-400 hover:text-white font-bold">
            <span className="text-base">
              🚨
            </span>
            <span className="text-[10px]">
              SOS Incidents
            </span>
          </a>
          <a href="/admin" className="flex flex-col items-center text-slate-400 hover:text-white">
            <span className="text-base">
              🗺️
            </span>
            <span className="text-[10px]">
              District Map
            </span>
          </a>
          <a href="/sector-patrol" className="flex flex-col items-center text-slate-400 hover:text-white">
            <span className="text-base">
              🚓
            </span>
            <span className="text-[10px]">
              Superior Patrol
            </span>
          </a>
        </div>
      </div>
      {/* EMERGENCY PING MODAL */}
      <div id="emergency-modal" className="hidden fixed inset-0 z-50 bg-black/80 backdrop-blur-sm flex items-center justify-center p-4">
        <div className="bg-slate-900 border-2 border-red-500 rounded-3xl w-full max-w-sm p-5 shadow-2xl text-slate-200">
          <div className="flex items-center justify-between pb-2 border-b border-slate-800 mb-3">
            <div className="flex items-center gap-2 text-red-500 font-bold text-base">
              <span className="text-2xl">
                🚨
              </span>
              {' '}Ping Allotted Superior Officer
            </div>
            <button id="btn-close-emergency" className="text-slate-400 hover:text-white text-lg">
              ×
            </button>
          </div>
          <p className="text-xs text-slate-300 mb-3">
            Select emergency category. Your Sub-Inspector (SHO) and Circle Inspector will be notified instantly with your live coordinates:
          </p>
          <div className="space-y-3 mb-4">
            <div>
              <label className="block text-xs font-semibold text-slate-300 mb-1">
                Emergency Category:
              </label>
              <select id="emergency-reason-select" className="w-full bg-slate-950 border border-slate-700 rounded-lg p-2 text-xs text-white">
                <option value="Crowd Unrest & Queuing Violence">
                  Crowd Unrest & Queuing Violence
                </option>
                <option value="EVM Tampering / Machine Technical Glitch">
                  EVM Tampering / Machine Technical Glitch
                </option>
                <option value="Unauthorized Gathering inside 100m Perimeter">
                  Unauthorized Gathering inside 100m Perimeter
                </option>
                <option value="Medical Emergency / Polling Officer Collapse">
                  Medical Emergency / Polling Officer Collapse
                </option>
                <option value="Armed Threat / Security Breach">
                  Armed Threat / Security Breach
                </option>
                <option value="Need Armed Relief Force">
                  Need Armed Relief Force
                </option>
              </select>
            </div>
            <div>
              <label className="block text-xs font-semibold text-slate-300 mb-1">
                Additional Notes / Booth Location:
              </label>
              <input type="text" id="emergency-notes" placeholder="e.g. Near Gate 1, Need 4 personnel" className="w-full bg-slate-950 border border-slate-700 rounded-lg p-2 text-xs text-white placeholder-slate-500" />
            </div>
          </div>
          <div className="flex gap-2">
            <button onClick={(event) => { document.getElementById('emergency-modal').classList.add('hidden') }} className="flex-1 py-2 bg-slate-800 hover:bg-slate-700 rounded-xl text-xs font-semibold text-slate-300">
              Cancel
            </button>
            <button id="btn-confirm-emergency" className="flex-1 py-2 bg-red-600 hover:bg-red-500 text-white rounded-xl text-xs font-bold shadow-lg shadow-red-900/50">
              CONFIRM & PING
            </button>
          </div>
        </div>
      </div>
      {/* APPLICATION SCRIPTS */}
    </>
  );
}
